module.exports = __webpack_public_path__ + "static/lap_mac-66347bd73d14456806e0fa75a8a0b747.webp";